export enum STATSIG_EVENTS {
  business_profile_complete = 'business_profile_complete',
}
